import { Button, Select, Space } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { correosPuedeAutorizarMasivo } from "../../../constants/cons";
import { useHistory } from "react-router-dom/";

export const BotonAutorizarMasivo = ({ selectedOption, onOptionChange }) => {
  const hisotory = useHistory();
  const { email } = useSelector((state) => state.userReducer.user);

  const options = [
    { label: "Todas las órdenes", value: "todos" },
    { label: "Sin Pagos Directos", value: "sin" },
    { label: "Solo Pagos Directos", value: "solo" },
  ];

  return (
    <Space>
      {correosPuedeAutorizarMasivo.includes(email) && (
        <Button
          onClick={() => hisotory.push("/ordenesPago/AutorizarMasivo")}
          type="link"
        >
          Autorizar Masivo
        </Button>
      )}
      <Select
        value={selectedOption}
        onChange={onOptionChange}
        options={options}
      />
    </Space>
  );
};
